import React from 'react'
import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'
import View from '../../../../../components/pdf/View'
import Text from '../../../../../components/pdf/Text'
import Separator from '../../../../../components/helpers/Separator'
import Header from './sections/Header'
import {
  getMoslerList,
  getMoslerRiskClass,
  getMoslerValue,
  getMoslerVulnerabilityDegree,
  sumGrauProtecaoByCategoryId,
  sumGrauVulnerabilidadeByCategoryId,
  sumValueByCategoryId
} from '../../_helpers/pdfHelpers'

const MetodoMosler = ({ headerValues, moslerValues, diagSegValues }) => {
  const incendioComVitimaFatalValue = getMoslerValue(moslerValues.incendioComVitimaFatal)
  const incendioSemVitimaFatalValue = getMoslerValue(moslerValues.incendioSemVitimaFatal)
  const desinteligenciaSemVitimaFatalValue = getMoslerValue(moslerValues.desinteligenciaSemVitimaFatal)
  const desinteligenciaComVitimaFatalValue = getMoslerValue(moslerValues.desinteligenciaComVitimaFatal)
  const furtosInternosValue = getMoslerValue(moslerValues.furtosInternos)
  const rouboComVitimaFatalValue = getMoslerValue(moslerValues.rouboComVitimaFatal)
  const rouboSemVitimaFatalValue = getMoslerValue(moslerValues.rouboSemVitimaFatal)
  const estuproValue = getMoslerValue(moslerValues.estupro)
  const acessoIndevidoTIValue = getMoslerValue(moslerValues.acessoIndevidoTI)
  const obitoPosMalSubitoValue = getMoslerValue(moslerValues.obitoPosMalSubito)
  const ameacaBombaValue = getMoslerValue(moslerValues.ameacaBomba)
  const explosaoValue = getMoslerValue(moslerValues.explosao)
  const suicidioValue = getMoslerValue(moslerValues.suicidio)

  const prevCombateIncendioValue = diagSegValues.find(item => item.type === 'sistemasGerais')?.prevencaoCombateIncendios
    ?.result
  const grauProtecaoSS = diagSegValues.find(item => item.type === 'hallElevSS')?.grauProtecao
  const grauProtecaoRecep = diagSegValues.find(item => item.type === 'recepcoes')?.grauProtecao
  const controlAccessPrivados = diagSegValues.find(item => item.type === 'andaresInternos')?.controlAccess

  const mediaGPeV = (grauProtecaoSS + grauProtecaoRecep + controlAccessPrivados) / 3

  const listaRiscoPotenciais = getMoslerList(moslerValues, prevCombateIncendioValue, mediaGPeV)

  const mediaPCIGR = sumValueByCategoryId(listaRiscoPotenciais, [23, 24, 31, 34])
  const mediaCAGR = sumValueByCategoryId(listaRiscoPotenciais, [25, 33, 26, 27, 28, 29, 30, 32, 34, 35])

  const mediaPCIGP = sumGrauProtecaoByCategoryId(listaRiscoPotenciais, [23, 24, 31, 34])
  const mediaCAGP = sumGrauProtecaoByCategoryId(listaRiscoPotenciais, [33, 30, 32, 35])

  const mediaPCIGV = sumGrauVulnerabilidadeByCategoryId(listaRiscoPotenciais, [23, 24, 31, 34])
  const mediaCAGV = sumGrauVulnerabilidadeByCategoryId(listaRiscoPotenciais, [25, 33, 26, 27, 28, 29, 30, 32, 34, 35])

  return (
    <View pageBreakAfter>
      <Header headerValues={headerValues} />

      <Table width="100%" useFontBaseColor>
        <TableRow useFontBaseColor bgColor="#f2f2f2">
          <TableCol colSpan={2} useFontBaseColor>
            <Text bold align="center">
              RISCO
            </Text>
          </TableCol>
          <TableCol colSpan={2} useFontBaseColor>
            <Text bold align="center" size={7}>
              FUNÇÃO
            </Text>
            <Text align="center" size={7}>
              As consequências negativas ou danos que podem alterar a atividade principal da empresa ou propriedade.
            </Text>
          </TableCol>
          <TableCol colSpan={2} useFontBaseColor>
            <Text bold align="center" size={7}>
              SUBSTITUIÇÃO
            </Text>
            <Text align="center" size={7}>
              Grau de dificuldade para substituição dos bens, após a concretização da ameaça.
            </Text>
          </TableCol>
          <TableCol colSpan={2} useFontBaseColor>
            <Text bold align="center" size={7}>
              PROFUNDIDADE
            </Text>
            <Text align="center" size={7}>
              Uma vez materializado o risco mede a perturbação e efeitos psicológicos causados sobre a imagem
            </Text>
          </TableCol>
          <TableCol colSpan={2} useFontBaseColor>
            <Text bold align="center" size={7}>
              EXTENSÃO
            </Text>
            <Text align="center" size={7}>
              O alcance dos danos segundo sua amplitude ou extensão podem ser: (repercussão)
            </Text>
          </TableCol>
          <TableCol colSpan={2} useFontBaseColor>
            <Text bold align="center" size={7}>
              AGRESSÃO PROBABILIDADE
            </Text>
            <Text align="center" size={7}>
              Mede a possibilidade do dano ou risco vir a acontecer, tendo em vista as características conjunturais e
              físicas da empresa, propriedade, complexo, cidade e estado onde ela se encontra.
            </Text>
          </TableCol>
          <TableCol colSpan={2} useFontBaseColor>
            <Text bold align="center" size={7}>
              VULNERABILIDADE (IMPACTO FINANCEIRO)
            </Text>
            <Text align="center" size={7}>
              Mede qual o nível de perdas causadas após a concretização do risco, considerando o critério de agressão.
              Conseguindo ultrapassar as medidas de proteção.
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold align="center" size={9}>
              CR (CxPb)
            </Text>
          </TableCol>
          <TableCol width="15%" useFontBaseColor>
            <Text bold align="center" size={9}>
              CLASSE DE RISCO
            </Text>
          </TableCol>
        </TableRow>

        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              1
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              INCÊNDIO COM VÍTIMA FATAL
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioComVitimaFatal[0]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioComVitimaFatal[0]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioComVitimaFatal[1]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioComVitimaFatal[1]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioComVitimaFatal[2]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioComVitimaFatal[2]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioComVitimaFatal[3]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioComVitimaFatal[3]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioComVitimaFatal[4]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioComVitimaFatal[4]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioComVitimaFatal[5]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioComVitimaFatal[5]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              {incendioComVitimaFatalValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7} preLine>
              {getMoslerRiskClass(incendioComVitimaFatalValue)}
            </Text>
          </TableCol>
        </TableRow>

        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              2
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              INCÊNDIO SEM VÍTIMA FATAL
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioSemVitimaFatal[0]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioSemVitimaFatal[0]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioSemVitimaFatal[1]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioSemVitimaFatal[1]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioSemVitimaFatal[2]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioSemVitimaFatal[2]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioSemVitimaFatal[3]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioSemVitimaFatal[3]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioSemVitimaFatal[4]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioSemVitimaFatal[4]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioSemVitimaFatal[5]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.incendioSemVitimaFatal[5]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              {incendioSemVitimaFatalValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7} preLine>
              {getMoslerRiskClass(incendioSemVitimaFatalValue)}
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              3
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              DESINTELIGÊNCIA SEGUIDA DE VIOLÊNCIA CONTRA FUNCIONÁRIOS - SEM VÍTIMA FATAL
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaSemVitimaFatal[0]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaSemVitimaFatal[0]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaSemVitimaFatal[1]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaSemVitimaFatal[1]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaSemVitimaFatal[2]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaSemVitimaFatal[2]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaSemVitimaFatal[3]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaSemVitimaFatal[3]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaSemVitimaFatal[4]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaSemVitimaFatal[4]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaSemVitimaFatal[5]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaSemVitimaFatal[5]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              {desinteligenciaSemVitimaFatalValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7} preLine>
              {getMoslerRiskClass(desinteligenciaSemVitimaFatalValue)}
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              4
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              DESINTELIGÊNCIA SEGUIDA DE VIOLÊNCIA CONTRA FUNCIONÁRIOS - COM VÍTIMA FATAL
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaComVitimaFatal[0]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaComVitimaFatal[0]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaComVitimaFatal[1]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaComVitimaFatal[1]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaComVitimaFatal[2]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaComVitimaFatal[2]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaComVitimaFatal[3]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaComVitimaFatal[3]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaComVitimaFatal[4]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaComVitimaFatal[4]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaComVitimaFatal[5]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.desinteligenciaComVitimaFatal[5]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              {desinteligenciaComVitimaFatalValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7} preLine>
              {getMoslerRiskClass(desinteligenciaComVitimaFatalValue)}
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              5
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              FURTOS INTERNOS PRATICADOS POR AGENTES EXTERNOS
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.furtosInternos[0]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.furtosInternos[0]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.furtosInternos[1]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.furtosInternos[1]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.furtosInternos[2]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.furtosInternos[2]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.furtosInternos[3]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.furtosInternos[3]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.furtosInternos[4]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.furtosInternos[4]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.furtosInternos[5]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.furtosInternos[5]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              {furtosInternosValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7} preLine>
              {getMoslerRiskClass(furtosInternosValue)}
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              6
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              ROUBO OU TENTATIVA COM VÍTIMA FATAL
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboComVitimaFatal[0]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboComVitimaFatal[0]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboComVitimaFatal[1]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboComVitimaFatal[1]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboComVitimaFatal[2]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboComVitimaFatal[2]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboComVitimaFatal[3]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboComVitimaFatal[3]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboComVitimaFatal[4]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboComVitimaFatal[4]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboComVitimaFatal[5]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboComVitimaFatal[5]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              {rouboComVitimaFatalValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7} preLine>
              {getMoslerRiskClass(rouboComVitimaFatalValue)}
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              7
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              ROUBO OU TENTATIVA SEM VÍTIMA FATAL
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboSemVitimaFatal[0]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboSemVitimaFatal[0]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboSemVitimaFatal[1]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboSemVitimaFatal[1]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboSemVitimaFatal[2]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboSemVitimaFatal[2]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboSemVitimaFatal[3]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboSemVitimaFatal[3]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboSemVitimaFatal[4]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboSemVitimaFatal[4]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboSemVitimaFatal[5]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.rouboSemVitimaFatal[5]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              {rouboSemVitimaFatalValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7} preLine>
              {getMoslerRiskClass(rouboSemVitimaFatalValue)}
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              8
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              ESTUPRO
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.estupro[0]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.estupro[0]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.estupro[1]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.estupro[1]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.estupro[2]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.estupro[2]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.estupro[3]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.estupro[3]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.estupro[4]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.estupro[4]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.estupro[5]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.estupro[5]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              {estuproValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7} preLine>
              {getMoslerRiskClass(estuproValue)}
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              9
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              MANIPULAÇÃO/ACESSO INDEVIDO A DADOS E INFORMAÇÕES EM AMBIENTE TÉCNICO/CRÍTICO - (SALAS DE "TI")
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.acessoIndevidoTI[0]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.acessoIndevidoTI[0]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.acessoIndevidoTI[1]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.acessoIndevidoTI[1]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.acessoIndevidoTI[2]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.acessoIndevidoTI[2]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.acessoIndevidoTI[3]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.acessoIndevidoTI[3]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.acessoIndevidoTI[4]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.acessoIndevidoTI[4]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.acessoIndevidoTI[5]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.acessoIndevidoTI[5]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              {acessoIndevidoTIValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7} preLine>
              {getMoslerRiskClass(acessoIndevidoTIValue)}
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              10
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              ÓBITO APÓS MAL SÚBITO
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.obitoPosMalSubito[0]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.obitoPosMalSubito[0]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.obitoPosMalSubito[1]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.obitoPosMalSubito[1]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.obitoPosMalSubito[2]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.obitoPosMalSubito[2]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.obitoPosMalSubito[3]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.obitoPosMalSubito[3]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.obitoPosMalSubito[4]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.obitoPosMalSubito[4]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.obitoPosMalSubito[5]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.obitoPosMalSubito[5]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              {obitoPosMalSubitoValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7} preLine>
              {getMoslerRiskClass(obitoPosMalSubitoValue)}
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              11
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              AMEAÇA DE BOMBA
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.ameacaBomba[0]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.ameacaBomba[0]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.ameacaBomba[1]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.ameacaBomba[1]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.ameacaBomba[2]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.ameacaBomba[2]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.ameacaBomba[3]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.ameacaBomba[3]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.ameacaBomba[4]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.ameacaBomba[4]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.ameacaBomba[5]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.ameacaBomba[5]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              {ameacaBombaValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7} preLine>
              {getMoslerRiskClass(ameacaBombaValue)}
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              12
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              EXPLOSÃO DE ARTEFATO
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.explosao[0]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.explosao[0]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.explosao[1]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.explosao[1]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.explosao[2]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.explosao[2]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.explosao[3]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.explosao[3]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.explosao[4]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.explosao[4]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.explosao[5]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.explosao[5]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              {explosaoValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7} preLine>
              {getMoslerRiskClass(explosaoValue)}
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              13
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              ATENTADO À PRÓPRIA VIDA (SUICÍDIO)
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.suicidio[0]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.suicidio[0]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.suicidio[1]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.suicidio[1]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.suicidio[2]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.suicidio[2]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.suicidio[3]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.suicidio[3]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.suicidio[4]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.suicidio[4]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.suicidio[5]?.replyValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7}>
              {moslerValues.suicidio[5]?.stringReply}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7}>
              {suicidioValue}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text semibold align="center" size={7} preLine>
              {getMoslerRiskClass(suicidioValue)}
            </Text>
          </TableCol>
        </TableRow>
      </Table>

      <Separator weight={20} />

      <Table width="100%" useFontBaseColor>
        <TableRow bgColor="#000" useFontBaseColor>
          <TableCol colSpan={3} useFontBaseColor>
            <Text semibold color="#FFF" align="center">
              MATRIZ DE CLASSIFICAÇÃO RISCOS E GRAU DE VULNERABILIDADE
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol colSpan={3} useFontBaseColor>
            <Text semibold>{headerValues.local}</Text>
          </TableCol>
        </TableRow>
      </Table>

      <Table width="100%" useFontBaseColor>
        <TableRow bgColor="#F2F2F2" useFontBaseColor>
          <TableCol colSpan={2} width="30%" useFontBaseColor>
            <Text align="center" semibold size={12}>
              RISCOS POTENCIAIS
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7} semibold>
              CR
            </Text>
            <Text align="center" size={7} semibold>
              (CxPb)
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7} semibold>
              CLASSE DE RISCO
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7} semibold>
              GP
            </Text>
            <Text align="center" size={7} semibold>
              GRAU DE PROTEÇÃO
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text align="center" size={7} semibold>
              GRAU DE VULNERABILIDADE
            </Text>
          </TableCol>
          <TableCol></TableCol>
        </TableRow>
        {listaRiscoPotenciais.map((item, index) => {
          return (
            <>
              <TableRow useFontBaseColor>
                <TableCol useFontBaseColor>
                  <Text align="center" size={7} semibold>
                    {index + 1}
                  </Text>
                </TableCol>
                <TableCol useFontBaseColor>
                  <Text align="center" size={7} semibold>
                    {item.category}
                  </Text>
                </TableCol>
                <TableCol useFontBaseColor bgColor="#ffc000">
                  <Text align="center" size={8} semibold>
                    {item.value}
                  </Text>
                </TableCol>
                <TableCol useFontBaseColor>
                  <Text align="center" size={7} semibold preLine>
                    {item.classRisk}
                  </Text>
                </TableCol>
                <TableCol useFontBaseColor bgColor="#548dd4">
                  <Text align="center" size={8} semibold>
                    {item.grauProtecao.toFixed(1)}
                  </Text>
                </TableCol>
                <TableCol useFontBaseColor bgColor="#ff0000">
                  <Text align="center" size={8} semibold>
                    {item.grauVulnerabilidade.toFixed(1)}
                  </Text>
                </TableCol>
                <TableCol useFontBaseColor>
                  <Text align="center" size={7} semibold>
                    {getMoslerVulnerabilityDegree(item.grauVulnerabilidade)}
                  </Text>
                </TableCol>
              </TableRow>
            </>
          )
        })}
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colSpan={2}>
            <Text align="center" size={7} semibold></Text>
          </TableCol>
          <TableCol useFontBaseColor colSpan={2} bgColor="#ffc000">
            <Text align="center" size={16} semibold>
              GR
            </Text>
          </TableCol>
          <TableCol useFontBaseColor bgColor="#548dd4">
            <Text align="center" size={16} semibold>
              GP
            </Text>
          </TableCol>
          <TableCol useFontBaseColor colSpan={2} bgColor="#ff0000">
            <Text align="center" size={16} semibold>
              GV
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colSpan={2}>
            <Text align="center" size={7} semibold></Text>
          </TableCol>
          <TableCol useFontBaseColor colSpan={2} bgColor="#ffc000">
            <Text align="center" size={7} semibold>
              ÍNDICE MÉDIO DO GRAU DE RISCOS (MÉTODO DE MOSLER)
            </Text>
          </TableCol>
          <TableCol useFontBaseColor bgColor="#548dd4">
            <Text align="center" size={7} semibold>
              ÍNDICE MÉDIO DO GRAU DE PROTEÇÃO ALCANÇADO NA EDIFICAÇÃO 0-99,8
            </Text>
          </TableCol>
          <TableCol useFontBaseColor colSpan={2} bgColor="#ff0000">
            <Text align="center" size={7} semibold>
              ÍNDICE MÉDIO DO GRAU DE VULNERABILIDADE DA EDIFICAÇÃO 0-99,8
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colSpan={2}>
            <Text align="center" size={10} semibold>
              PREVENÇÃO E COMBATE A INCÊNDIOS
            </Text>
          </TableCol>
          <TableCol useFontBaseColor colSpan={2} bgColor="#ffc000">
            <Text align="center" size={16} semibold>
              {mediaPCIGR.toFixed(1)}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor bgColor="#548dd4">
            <Text align="center" size={16} semibold>
              {mediaPCIGP.toFixed(1)}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor colSpan={2} bgColor="#ff0000">
            <Text align="center" size={16} semibold>
              {mediaPCIGV.toFixed(1)}
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor>
          <TableCol useFontBaseColor colSpan={2}>
            <Text align="center" size={10} semibold>
              CONTROLE DE ACESSO
            </Text>
          </TableCol>
          <TableCol useFontBaseColor colSpan={2} bgColor="#ffc000">
            <Text align="center" size={16} semibold>
              {mediaCAGR.toFixed(1)}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor bgColor="#548dd4">
            <Text align="center" size={16} semibold>
              {mediaCAGP.toFixed(1)}
            </Text>
          </TableCol>
          <TableCol useFontBaseColor colSpan={2} bgColor="#ff0000">
            <Text align="center" size={16} semibold>
              {mediaCAGV.toFixed(1)}
            </Text>
          </TableCol>
        </TableRow>
      </Table>
    </View>
  )
}

export default MetodoMosler
